<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h2 class="mb-0">
            {{ $tc('message.generalConsultations', 1) }}
          </h2>
        </div>
      </div>

      <div class="card-body">
        <b-tabs
            card
            content-class="mt-3"
            fill
            active-nav-item-class="font-weight-bold text-uppercase text-success"

        >
          <b-tab no-body :title="$t('message.infoConsultation')">
            <b-row>
              <b-col col sm="8">
                <div class="list-group">
                  <b-row>
                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title"> {{ $t('message.institutionConsultation') }} </h4>
                        <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ etablissement }} </p>
                                                </span>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title"> {{ $tc('message.practitioners',1) }} </h4>
                        <span class="font-weight-bold">
                                                    <p class="consultation-item__body"> {{ praticien }} </p>
                                                </span>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3" v-if="contributeurs.length>0">
                      <div class="">
                        <h4 class="consultation-item__title"> {{ $tc('message.contributors',2) }} </h4>
                        <span class="font-weight-bold" v-for="contributeur in contributeurs" :key="contributeur.nom">
                                                    <p class="consultation-item__body"> {{ contributeur.nom }} </p>
                                                </span>
                      </div>
                    </b-col>

                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.consultationDate') }} </h4>

                        <p class="consultation-item__body"> {{ formattedDate(mConsultation.date_consultation) }} </p>
                      </div>
                    </b-col>
                    <b-col col sm="12" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title"> {{ $tc('message.reasons', 1) }} </h4>
                        <p class="consultation-item__body">{{ reasons }}</p>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <div class="mb-3">
                       <b-col col sm="12" class="mb-3">
                      <h4 class="consultation-item__title"> {{ $t('message.lifestyle') }} </h4>
                      <b-table striped hover :items="modeDeVie"></b-table> 
                      <h4 class="consultation-item__title"> {{ $t('message.autres') }} </h4>
                       <div v-html="this.generalConsultation.autres">
                       </div>
                       </b-col>
                      </div>                    
                  </b-row>
                  <!--//Antecedent-->
<!--                   <b-row>
                    <b-col col sm="12" class="mb-3">

                      <h4 class="consultation-item__title">{{ $tc('message.antecedents',2) }} </h4>

                      <div v-if="antecedentsRows">
                        <b-list-group>
                          <b-list-group-item v-for="(antecedent,key) in antecedentsRows" :key="key" class="d-flex justify-content-between align-items-center">
                            <b-badge variant="primary" pill>{{antecedent.type}}</b-badge>
                            <p class="consultation-item__body ml-3" v-html="antecedent.description"> </p>
                          </b-list-group-item>
                        </b-list-group>
                      </div>

                    </b-col>
                  </b-row> -->
                  <!--                                    //Allergies-->
<!--                   <b-row>
                    <b-col col sm="12" class="mb-3">

                      <h4 class="consultation-item__title"> {{ $tc('message.allergies',2) }} </h4>
                    
                      <div v-for="allergy in allergiesRows" :key="allergy.slug">
                        <p class="consultation-item__body">{{allergy.description}}</p>
                      </div>
                 
                    </b-col>
                  </b-row> -->
                  <!--//Traitement courant-->
                  <b-row>
                    <b-col col sm="12" class="mb-3">
                      <h4 class="consultation-item__title">{{ $t('message.currentTreatments') }} </h4>
                      <div class="ml-3" v-if="traitementsRows">
                        <div>
                          <p class="consultation-item__body" v-html="lastTraitment"> </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <!--Parametres-->
<!--                   <b-row>
                    <b-col col sm="6" class="mb-3">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.parameter') }}</h4>

                        <div v-if="commonParametersRows">
                          <div class="ml-3" v-for="parameter in commonParametersRows" :key="parameter.slug">


                            <b-list-group>
                              <b-list-group-item class="consultation-item__body">  {{ $t('message.weight') }} :  {{ parameter.poids }} </b-list-group-item>
                              <b-list-group-item class="consultation-item__body"> {{ $t('message.height') }}  : {{ parameter.taille }} </b-list-group-item>
                              <b-list-group-item class="consultation-item__body">  {{ $t('message.bmi') }}  :  {{ parameter.bmi }} </b-list-group-item>
                              <b-list-group-item class="consultation-item__body"> {{ $t('message.taSystolique') }} : {{ parameter.taSystolique }} </b-list-group-item>
                              <b-list-group-item class="consultation-item__body"> {{ $t('message.taDiastolique') }} :{{ parameter.taDiastolique }} </b-list-group-item>
                              <b-list-group-item class="consultation-item__body"> {{ $t('message.temperature') }}  :{{ parameter.temperature }} </b-list-group-item>
                              <b-list-group-item class="consultation-item__body">  {{ $t('message.heartRate') }}  :{{ parameter.frequence_cardiaque }} </b-list-group-item>
                              <b-list-group-item class="consultation-item__body">  {{ $t('message.respiratoryRate') }}  : {{ parameter.frequence_respiratoire }} </b-list-group-item>
                              <b-list-group-item class="consultation-item__body">  {{ $t('message.sato2') }}  : {{ parameter.sato2 }} </b-list-group-item>
                            </b-list-group>


                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row> -->

<!--                   <b-row class="mb-3">
                    <b-col col sm="12" class="mb-3">

                      <h4 class="consultation-item__title">{{ $tc('message.physicalExams',2) }} </h4>

                      <p class="consultation-item__body" v-html="mConsultation.examen_clinique">  </p>

                    </b-col>
                    <b-col col sm="12">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $tc('message.complementaryExams',2) }} </h4>

                        <p class="consultation-item__body" v-html="mConsultation.examen_complementaire"></p>

                      </div>
                    </b-col>
                  </b-row> -->
                  <!--                                    //Diagnostic-->


                  <b-row>
                    <b-col col sm="12">
                      <div class="">
                        <h4 class="consultation-item__title"> {{ $t('message.suggestTreatment') }} </h4>
                        <p class="consultation-item__body" v-html="mConsultation.traitement_propose"> </p>
                      </div>
                    </b-col>


                    <b-col col sm="12" v-if="mConsultation.rdv">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.appointmentDate') }} </h4>

                        <p class="consultation-item__body" v-html="mConsultation.rdv.date"></p>

                      </div>
                    </b-col>
                    <b-col col sm="12" v-if="mConsultation.rdv">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.appointmentReason') }} </h4>

                        <p class="consultation-item__body" v-html="mConsultation.rdv.motifs"></p>

                      </div>
                    </b-col>

                    <b-col col sm="12" v-if="mConsultation.rdv">
                      <div class="">
                        <h4 class="consultation-item__title">{{ $t('message.doctorName') }} </h4>

                        <p class="consultation-item__body" v-if="mConsultation.rdv.praticien != null" v-html="`${mConsultation.rdv.praticien.prenom} ${(mConsultation.rdv.praticien.nom).toUpperCase()} `"></p>
                        <p class="consultation-item__body" v-else v-html="mConsultation.rdv.nom_medecin"></p>

                      </div>
                    </b-col>
                  </b-row>
                </div>

              </b-col>
              <b-col col sm="4">
                <b-row class="justify-content-sm-center">

                  <div class="card-footer text-right">
                    <div v-if="!hasGestionnaireRole" @click="ImprimerConsultation" class="custom-print-wrapper">
                      <button class="custom-print-button">
                        <span class="custom-print-icon"></span>
                      </button>
                      <p class="custom-print-label">
                        {{ $t('message.print') }}  {{ $tc('message.consultations', 1) }}
                      </p>
                    </div>
                    <br>
                    <b-button variant="primary" @click="updateConsultation" v-if="canUpdate">
                      {{ $t('message.edit') }}
                    </b-button>
                    <br>
                    <br>

                    <b-button variant="success" @click="archieveConsultation" v-if="!isTransmitted(mConsultation.passed_at) && isArchived(mConsultation.archieved_at) && (hasMedecinControleRole || hasAdminRole)" >
                      {{ $t('message.archieve') }}
                    </b-button>
                    <br>
                    <b-button variant="info" @click="transmitConsultation" v-if="isTransmitted(mConsultation.passed_at) && mConsultation.isAuthor && (hasPraticienRole || hasAdminRole || hasMedecinControleRole)">
                      {{ $t('message.transmit') }}
                    </b-button>
                    <br>
                    <br>

                    <b-button variant="info" @click="reactiveConsultation" v-if="canReactive">
                      {{ $t('message.reavivate') }} {{$tc('message.consultations',1) }}
                    </b-button>
                    <br>
                    <br>

                    <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                      {{ $t('message.delete') }}
                    </b-button>
                    <br>
                    <p v-if="errorshasField('nonTransmis')" style="color:red"  class="justify-content-sm-center">
                      {{getErrorsField('nonTransmis')}}
                    </p>
                  </div>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col col sm="12">
                <h4 v-if="isDefine">Fichier joint </h4>
                <img :src="image" class="card-img-top" alt="Image does not show" style="width: 250px; height: auto" v-if="isImage && isDefine">
                <span v-else-if="isDefine && !isImage && image.length >0"><a :href="image" download> Download file </a></span>
                <div v-if="files.length>0">
                  <div  v-for="file in files" :key="file.id">
                    <b-row>
                      <b-col col sm="6">
                        <p class="mb-3"> {{file.nom}}</p>
                      </b-col>
                      <b-col col sm="6">
                        <button type="button" class=" ml-5 btn btn-success btn-sm" @click="openFile(file)">Afficher</button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab no-body title="Anamneses">
            <b-container class="bv-example-row">
              <!-- <b-row v-html="mConsultation.anamese"></b-row> -->
              <editor
                v-if="mConsultation.anamese"
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="mConsultation.anamese"
                      :init="{
                              height: 650,
                              width: 950,
                              menubar: false,
                              plugins: plugins,
                              toolbar:toolbar,
                            }"
                  disabled>
                  </editor>
              <b-row>  
                  <div v-for="(c,key) in anamneses" :key="key" class="col-lg-4 mt-4">
                    <h4 class="text-danger">{{key}}</h4>
                    <b-table striped hover :items="anamneses"></b-table>
                      <div :label="key" class="">
                              <div v-for="(item, index) in c" :key="index" >
                                  <span>{{item.fr_description}}</span>
                              </div>
                      </div>
                  </div>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab no-body :title=" $t('message.parameter')" :active="pathHas('parametreCommun')">
            <b-col sm="12">
    
              <div class="list-group list-group-flush" id="parametreCommun">
                <b-link class="ml-4"
                        @click="toAddCommonParameter"
                        variant="primary"
                        v-if="(hasAdminRole) || ( (hasPraticienRole || hasMedecinControleRole) && commonParametersRows.length==0 && isAuthor)"
                >
                  <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.parameter') }}
                </b-link>

                <b-card-body>
                  <b-row>
                    <b-col>
                    <h3 class="mt-3">Glucide</h3>
                        <b-row v-for="(c,key) in glucydes" :key="key">
                            <b-col class="col-sm-8"> {{getTranslate(key)}} </b-col> <b-col> {{c}} </b-col> 
                        </b-row>
                    </b-col>
                    <b-col>
                      <h3>Lipides</h3>
                        <b-row v-for="(c,key) in lipides" :key="key">
                            <b-col class="col-sm-8"> {{getTranslate(key)}} </b-col> <b-col> {{c}}</b-col>
                        </b-row>
                    </b-col>
                    <b-col>
                      <h3>Nutrition</h3>
                        <b-row v-for="(c,key) in nutritions" :key="key">
                            <b-col> {{getTranslate(key)}}: </b-col><b-col :variant="c==='true' ? 'success':'danger' ">{{getVerification(c)}}</b-col>
                        </b-row>
                    </b-col>
                  </b-row>  
                  <vue-good-table class="mt-5"
                      v-if="commonParametersRows"
                      :columns="commonParametersColumns"
                      :rows="commonParametersRows"
                      :search-options="enabled"
                      :pagination-options="paginationOptions"
                      @on-row-click="commonParametersRowClick"

                  />
                </b-card-body>
              </div>

            </b-col>

          </b-tab>
          <b-tab no-body :title=" $t('message.conclusion')">
            <b-col sm="12">                
                          <div class="row">
                             <div class="mt-2 col-lg-3">
                                                    <b>ICD Codes</b>
                                                </div>
                                                <div class="mt-2 col-lg-9">
                                                    <b>Terminologies</b>
                                                </div></div>      
                                                <hr/>                  
                          <div v-for="(chose, key) in diagnotics" :key="key" class="text-left row appointment-item">
                                               
                                                <div class="mt-2 col-lg-3">
                                                    {{chose.code}}
                                                </div>
                                                <hr/> 
                                                <div class="mt-2 col-lg-9">
                                                    {{chose.bestMatchText}}
                                                </div>
                                            </div>  
                                                              <b-row class="mb-3">
                    <b-col col sm="12">
                      <div>
                        <div class="font-weight-bold" v-if="conclusionsRows.length > 0">
                          <div v-for="conclusion in conclusionsRows" :key="conclusion.slug">
                            <p class="consultation-item__body" v-html="conclusion.description">  </p>
                          </div>
                        </div>

                      </div>
                    </b-col>
                  </b-row>  
<!--               <div class="list-group list-group-flush" id="conclusion">

                <b-link class="ml-4"
                        @click="toConclusion"
                        variant="primary"
                        v-if="hasAdminRole || ( (hasPraticienRole || hasMedecinControleRole) && isAuthor) "
                >
                  <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.conclusion') }}
                </b-link>

                <b-card-body>
                  <vue-good-table
                      v-if="conclusionsRows.length > 0"
                      :columns="conclusionsColumns"
                      :rows="conclusionsRows"
                      :search-options="enabled"
                      :pagination-options="paginationOptions"
                      @on-row-click="conclusionsRowClick"

                  />
                </b-card-body>
              </div> -->
            </b-col>
          </b-tab>
          <b-tab :title=" $t('message.examenclinique')"> 
            <b-container class="bv-example-row mb-2">
              <div class="content" style=" box-shadow:none;">
              <b-row v-if="mConsultation.examen_clinique">
                <editor
                      
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="mConsultation.examen_clinique"
                      :init="{
                              height: 500,
                              width: 800,
                              menubar: false,
                              plugins: plugins,
                              toolbar:toolbar,
                            }"
                      disabled>
                  </editor>
              </b-row>
              </div>
              <b-row>  
                  <div v-for="(c,key) in examens" :key="key" class="col-lg-4 mt-4">
                    <h4 class="text-danger">{{key}}</h4>
                      <div :label="key" class="">
                              <div v-for="(item, index) in c" :key="index" >
                                  <span>{{item.fr_description}}</span>
                              </div>
                      </div>
                  </div>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab :title=" $t('message.examencomplementaire')">
            <b-container class="bv-example-row mb-2">
              <div class="content" style=" box-shadow:none;">
              <b-row v-if="mConsultation.examen_comp">
                <editor
                      
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="mConsultation.examen_comp"
                      :init="{
                              height: 500,
                              width: 800,
                              menubar: false,
                              plugins: plugins,
                              toolbar:toolbar,
                            }"
                      disabled>
                  </editor>
              </b-row>
              </div>
              <b-row> 
                  <div v-for="(map,key1) in complementaire" :key="key1" class="col-lg-4 mt-4">
                    <h4 class="text-danger">{{key1}}</h4>
                      <div :label="key1" class="">
                              <div v-for="(item, index) in map" :key="index">
                                  <span>{{item.fr_description}}</span>
                              </div>
                      </div>
                  </div>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab no-body :title="$t('message.currentTreatments')" :active="pathHas('traitement')">
            <b-col sm="12">
              <div class="list-group list-group-flush" id="traitement">
                <b-link class="ml-4"
                        @click="toCurrentTraitement"
                        variant="primary"
                        v-if="(hasAdminRole) || ((hasPraticienRole || hasMedecinControleRole) && isAuthor)"
                >
                  <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.currentTreatments') }}
                </b-link>

                <b-card-body>
                  <vue-good-table
                      v-if="traitementsRows"
                      :columns="traitementsColumns"
                      :rows="traitementsRows"
                      :search-options="enabled"
                      :pagination-options="paginationOptions"
                      @on-row-click="onTraitementRowClick"

                  />
                </b-card-body>
              </div>
            </b-col>
          </b-tab>
          <b-tab no-body :title="$t('message.infoAllergies')">
            <b-col sm="12">
              <div class="list-group list-group-flush" id="allergie">
                <b-link class="ml-4"
                        variant="primary"
                        @click="toAllergie"
                        v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole">
                  <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.allergies', 1) }}
                </b-link>

                <b-card-body>
                  <vue-good-table
                      v-if="notEmpty(allergiesRows)"
                      :columns="allergiesColumns"
                      :rows="allergiesRows"
                      :search-options="enabled"
                      :pagination-options="paginationOptions"
                      @on-row-click="onAllergieRowClick"
                  />
                </b-card-body>
              </div>
            </b-col>
          </b-tab>
          <b-tab no-body :title="$t('message.infoAntecedents')">
            <b-col sm="12">
              <div class="list-group list-group-flush" id="antecedent">
                <b-link class="ml-4" variant="primary"
                        @click="toAntecedent"
                        v-if="hasAdminRole || hasPraticienRole || hasMedecinControleRole"
                >
                  <i class="fas fa-plus-circle edit-icon"></i>  {{ $t('message.add') }} {{ $tc('message.antecedents', 1) }}
                </b-link>

                <b-card-body>
                  <vue-good-table
                      v-if="notEmpty(antecedentsRows)"
                      :columns="antecedentsColumns"
                      :rows="antecedentsRows"
                      :search-options="enabled"
                      :pagination-options="paginationOptions"
                      @on-row-click="onAntecedentRowClick"

                  />
                </b-card-body>
              </div>
            </b-col>
          </b-tab>

        </b-tabs>
        <div class="card">
          <b-modal
              id="delete-modal"
              size="sm"
              header-bg-variant="danger"
              header-text-variant="light"
              :title="$t('message.delete') + ' ' + $tc('message.generalConsultations', 1)"
              hide-footer
          >
            <div class="d-block text-center">
              <h3>{{ $t('message.delete') }} {{ formattedDate(mConsultation.date_consultation) }}</h3>
            </div>

            <div class="d-block float-right">
              <b-button variant="danger" @click="deleteConsultation" >
                {{ $t('message.delete') }}
              </b-button>

              <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                {{ $t('message.cancel') }}
              </b-button>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import $ from 'jquery';
import AppConfig from "../../../constants/AppConfig";
import Editor from '@tinymce/tinymce-vue';

export default {
  name: "GeneralMedicine",
  components: {
    editor: Editor
  },
  computed: {
    ...mapGetters(["generalConsultation",
      'errors',
      'hasAdminRole',
      'hasMedecinControleRole',
      "hasSouscripteurRole",
      "hasPatientRole",
      'hasPraticienRole',
      'hasGestionnaireRole']),

    image: function() {
      if (!_.isUndefined(this.mConsultation.file) && !_.isNull(this.mConsultation.file)){
        if (this.mConsultation.file.length >0 && this.mConsultation.file != 'null'){
          return AppConfig.imgUrl + '/public/storage/' + this.mConsultation.file;
        }
        return "";
      }
      return "";
    },

    isDefine:function(){
      return (this.generalConsultation.file != 'null' && !_.isNull(this.generalConsultation.file)) || this.files.length>0;
    },

    isImage:function(){
      if( this.generalConsultation.file != 'null' && !_.isEmpty(this.generalConsultation.file)){
        return (this.generalConsultation.file).includes('.jpeg') || (this.generalConsultation.file).includes('.png')|| (this.generalConsultation.file).includes('.jpg');
      }
      return  false;
    },

    mConsultation: function() {
      return this.generalConsultation;
    },
   
    modeDeVie: function(){
        return [
          { 
            'family situation': this.generalConsultation.situation_familiale,
            'profession': this.generalConsultation.profession,
            'enfants': this.generalConsultation.nbre_enfant,
            'tabac': this.generalConsultation.tabac,
            'alcool': this.generalConsultation.alcool,        
          },
        ];
    },

    contributeurs:function(){
      let cArray = [];
      if (!_.isUndefined(this.generalConsultation)){
        if (!_.isUndefined(this.generalConsultation.operationables)){
          _.forEach(this.generalConsultation.operationables,function (operation) {
            if (!_.isUndefined(operation.contributable)){
              let contributable = operation.contributable;
              let prenom = contributable.prenom != 'null' ? contributable.prenom : '';
              prenom =  prenom.toLowerCase();
              let nomComplet = (contributable.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
              cArray.push({nom:nomComplet})  ;
            }
          });
        }
      }
      return cArray;
    },

    files:function(){
      return _.isUndefined(this.mConsultation.files) ? [] :this.mConsultation.files;
    },

    isAuthor:function(){
      return this.mConsultation.isAuthor;
    },

    canUpdate:function(){
      return this.mConsultation.canUpdate;
    },

    canReactive:function(){
      return !_.isNull(this.mConsultation.passed_at) && (this.hasAdminRole || this.hasMedecinControleRole);
    },

    canDelete:function(){
      if (this.hasAdminRole)
        return true;

      return this.mConsultation.canUpdate && _.isNull(this.mConsultation.archieved_at) && _.isNull(this.mConsultation.passed_at);
    },

    etablissement:function(){
      if (!_.isUndefined(this.mConsultation)){
        if (!_.isUndefined(this.mConsultation.etablissement)){
          if (!_.isNull(this.mConsultation.etablissement)){
            return this.mConsultation.etablissement.name;
          }
          return "";
        }
      }
      return  "";
    },

    praticien:function(){
      let author = this.mConsultation.author;
      if (!_.isNull(author) && !_.isUndefined(author)){
        if (author.hasOwnProperty('user')){
          let user = author.user
          if (!_.isUndefined(user) && !_.isNull(user)) {
            let prenom = (user.prenom == null) ? '' : user.prenom;
            return (user.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
          }
        }else{
          if (!_.isUndefined(author) && !_.isNull(author)) {
            let prenom = (author.prenom == null) ? '' : author.prenom;
            return (author.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
          }
        }
      }
      return  "";
    },

    nom: function() {
      if (typeof(this.generalConsultation.dossier) =='object'){
        let user = this.generalConsultation.dossier.patient.user;

        let nom = user.nom;
        let prenom = user.prenom != null ? user.prenom : '';

        return  prenom +" "+ nom.toUpperCase();
      }else{
        return "";
      }
    },
    examens: function() {
      if(this.generalConsultation.examens === null){
        return null;
      }
      if(typeof this.generalConsultation.examens === 'string'){
       let test = JSON.parse(this.generalConsultation.examens);
          const groups = test.reduce((groups, item) => {
                const group = (groups[item.reference] || []);
                group.push(item);
                groups[item.reference] = group;
                return groups;
            }, {});
            return groups;
          }
        else if(typeof this.generalConsultation.examens === 'object'){
            const groups = this.generalConsultation.examens.reduce((groups, item) => {
                const group = (groups[item.reference] || []);
                group.push(item);
                groups[item.reference] = group;
                return groups;
            }, {});
            return groups;
        }else{
          return null;
        }
      
    },
    complementaire: function() {
      if(this.generalConsultation.examen_complementaire === ''){
        return null;
      }
      if(this.generalConsultation.examen_complementaire === 'null'){
        return null;
      }
      if (/^[\],:{}\s]*$/.test(this.generalConsultation.examen_complementaire.replace(/\\["\\\/bfnrtu]/g, '@').
        replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
        replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

       let test = JSON.parse(this.generalConsultation.examen_complementaire);
          const groups = test.reduce((groups, item) => {
                const group = (groups[item.reference] || []);
                group.push(item);
                groups[item.reference] = group;
                return groups;
            }, {});
            return groups;
            }
         else if(typeof this.generalConsultation.examen_complementaire === 'string'){
             return null;
        }
        else if(typeof this.generalConsultation.examen_complementaire === 'object'){
            const groups = this.generalConsultation.examen_complementaire.reduce((groups, item) => {
                const group = (groups[item.reference] || []);
                group.push(item);
                groups[item.reference] = group;
                return groups;
            }, {});
            return groups;
        }else{
          return null;
        }
      
    },
    examen_comp: function() {
      if(/^[\],:{}\s]*$/.test(this.mConsultation.examen_complementaire.replace(/\\["\\\/bfnrtu]/g, '@').
        replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
        replace(/(?:^|:|,)(?:\s*\[)+/g, ''))){
          return '';
      }
    },
    anamneses: function() {
      if(this.generalConsultation.anamneses === null){
        return null;
      }
      if(typeof this.generalConsultation.anamneses === 'string'){
       let test = JSON.parse(this.generalConsultation.anamneses);
          const groups = test.reduce((groups, item) => {
                const group = (groups[item.reference] || []);
                group.push(item);
                groups[item.reference] = group;
                return groups;
            }, {});
            return groups;
            }
        else if(typeof this.generalConsultation.anamneses === 'object'){
            const groups = this.generalConsultation.anamneses.reduce((groups, item) => {
                const group = (groups[item.reference] || []);
                group.push(item);
                groups[item.reference] = group;
                return groups;
            }, {});
            return groups;
        }else{
          return null;
        }
      
    },
    glucydes:function(){
            if(typeof this.generalConsultation.glucide === 'string'){
               return JSON.parse(this.generalConsultation.glucide);
            }
            else if(typeof this.generalConsultation.glucide === 'object'){
            return this.generalConsultation.glucide;
           }else{
            return null;
          }
    },
    lipides:function(){
            if(typeof this.generalConsultation.lipide === 'string'){
               return JSON.parse(this.generalConsultation.lipide);
            }
            else if(typeof this.generalConsultation.lipide === 'object'){
            return this.generalConsultation.lipide;
           }else{
            return null;
          }
    },
    nutritions:function(){
         if(typeof this.generalConsultation.nutrition === 'string'){
               return JSON.parse(this.generalConsultation.nutrition);
            }
            else if(typeof this.generalConsultation.nutrition === 'object'){
            return this.generalConsultation.nutrition;
           }else{
            return null;
          }
    },
    diagnotics:function(){
          if(typeof this.generalConsultation.diasgnostic === 'string'){
               return JSON.parse(this.generalConsultation.diasgnostic);
          }
          else if(typeof this.generalConsultation.diasgnostic === 'object'){
            return this.generalConsultation.diasgnostic;
           }else{
            return null;
          }
    },
    reasons:function(){
      let motifs ="";
      if(!_.isUndefined(this.mConsultation.motifs)){
        _.forEach(this.mConsultation.motifs,function (motif) {
          motifs += " "+motif.description;
        })
        return motifs;
      }

      return "";
    },
    

    allergiesRows:function(){
      let aArray = [];
      if(!_.isUndefined(this.mConsultation.dossier)) {
        _.forEach(this.mConsultation.dossier.allergies, function (allergy) {
          aArray.push({description: allergy.description, date: allergy.date, slug: allergy.slug})
        })
      }
      return aArray;
    },

    commonParametersRows:function(){
      let cArray = [];
      if(!_.isUndefined(this.mConsultation.parametres_commun)) {
        _.forEach(this.mConsultation.parametres_commun, function (parametre_commun) {
          cArray.push({taSystolique:parametre_commun.ta_systolique,taDiastolique:parametre_commun.ta_diastolique, poids:parametre_commun.poids,taille:parametre_commun.taille,temperature:parametre_commun.temperature,bmi:parametre_commun.bmi,frequence_respiratoire:parametre_commun.frequence_respiratoire, frequence_cardiaque:parametre_commun.frequence_cardiaque,sato2:parametre_commun.sato2,slug:parametre_commun.slug});
        });
      }
      return cArray;
    },

    antecedentsRows:function(){
      let mArray = [];
      if(!_.isUndefined(this.mConsultation.dossier)) {

        mArray = this.mConsultation.dossier.antecedents
        let cMedecines = this.mConsultation.dossier.consultations_medecine;
        let cCardiologies = this.mConsultation.dossier.cardiologies;
          /* 
        _.forEach(cCardiologies, function (cardiologie) {
          if (!_.isNull(cardiologie.conclusion) && cardiologie.conclusion !== 'null') {
            let c = {}
            c.type = 'Consultation';
            c.description = cardiologie.conclusion;
            c.date = moment(cardiologie.updated_at).format('YYYY-MM-DD');
            c.cardiology = cardiologie.slug;
            mArray.push(c);
          }
        });

        _.forEach(cMedecines, function (medecine) {
          _.forEach(medecine.conclusions, function (conclusion) {
            let m = {};
            m.type = 'Consultation';
            m.description = conclusion.description;
            m.date = moment(conclusion.updated_at).format('YYYY-MM-DD');
            m.medecine = medecine.slug;
            mArray.push(m);
          })
        }) */
      }
      return mArray;
    },

    traitementsRows:function(){
      let tArray = [];
      if(!_.isUndefined(this.mConsultation.dossier)) {
        _.forEach(this.mConsultation.dossier.traitements, function (traitement) {
          tArray.push({description: traitement.description,slug:traitement.slug})
          // tArray.push({date:traitement.created_at,description: traitement.description,slug:traitement.slug})
        });
      }
      return tArray;
    },

    conclusionsRows:function () {
      let cArray = [];
      if(!_.isUndefined(this.mConsultation.conclusions)) {
        _.forEach(this.mConsultation.conclusions, function (conclusion) {
          cArray.push({reference:conclusion.reference,description: conclusion.description,slug:conclusion.slug})
        });
      }
      return cArray;
    },

    reasonsRows:function(){
      let mArray = [];
      if(!_.isUndefined(this.mConsultation.motifs)) {
        _.forEach(this.mConsultation.motifs, function (motif) {
          mArray.push({reference:motif.reference,description: motif.description,slug:motif.slug})
        });
      }
      return mArray;
    },

    lastTraitment:function () {
      if (this.traitementsRows.length > 0){
        if (!_.isUndefined(this.traitementsRows[(this.traitementsRows.length -1)])){
          return (this.traitementsRows[(this.traitementsRows.length -1)]).description;
        }
        return "";
      }
      return "";
    },

  },

  data() {
    return {
      readonly: true,
      afficher : 0,
      tinyKey: AppConfig.tinyMceKey,
      plugins: [
        'advlist autolink lists  image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar: '',
      consultation_id: this.$route.params.consultation,

      commonParametersColumns:[
        {
          label: this.$i18n.t('message.weight'),
          field: 'poids',
        },

        {
          label:  this.$i18n.t('message.height'),
          field: 'taille',
        },

        {
          label:  this.$i18n.t('message.bmi'),
          field: 'bmi',
        },


        {
          label:  this.$i18n.t('message.taSystolique'),
          field: 'taSystolique',
        },

        {
          label:  this.$i18n.t('message.taDiastolique'),
          field: 'taDiastolique',
        },

        {
          label: this.$i18n.t('message.temperature'),
          field: 'temperature',
        },



        {
          label: this.$i18n.t('message.heartRate'),
          field: 'frequence_cardiaque',
        },

        {
          label: this.$i18n.t('message.respiratoryRate'),
          field: 'frequence_respiratoire',
        },

      ],

      traitementsColumns:[
        {
          label: 'Description',
          field: 'description',
          html: true,
        },
        // {
        //     label: this.$i18n.t('message.prescriptionDate'),
        //     field: 'date',
        //     type: 'date',
        //     dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
        //     dateOutputFormat: 'dd/MM/yyyy',
        // },
      ],

      reasonsColumns:[
        {
          label: this.$i18n.t('message.reference'),
          field: 'reference',
        },
        {
          label: this.$i18n.t('message.description'),
          field: 'description',
          html: true,
        },
      ],

      conclusionsColumns:[
        {
          label: this.$i18n.t('message.reference'),
          field: 'reference',
        },
        {
          label: this.$i18n.t('message.description'),
          field: 'description',
          html: true,
        },
      ],

      antecedentsColumns:[
        {
          label: this.$i18n.tc('message.types',1),
          field: 'type',
        },
        {
          label: 'Description',
          field: 'description',
          html: true,
        },
        {
          label: this.$i18n.t('message.startDate'),
          field: 'date',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd/MM/yyyy',
        },
      ],

      paginationOptions:{
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled:{enabled: true},

      sort:{
        enabled: true,
        initialSortBy: {field: 'date', type: 'desc'}
      },

      allergiesColumns: [
        {
          label: 'Description',
          field: 'description',
          html: true,
        },
        // {
        //     label: this.$i18n.t('message.startDate'),
        //     field: 'date',
        //     type: 'date',
        //     dateInputFormat: 'yyyy-MM-dd',
        //     dateOutputFormat: 'dd/MM/yyyy',
        // },
      ],
    }
  },

  methods: {
    openFile(file){
      window.open(AppConfig.imgUrl + '/public/storage/' + file.chemin);
    },
    ImprimerConsultation(){
      let args = {
        generale: this.consultation_id
      };

      this.$store.dispatch("printConsultationMedecine", { args });
    },

    reasonsRowClick(params){
      this.$router.push({ name: 'reason', params: { reason: params.row.slug } });

    },

    allerA(item){
      return this.$route.path + item;
    },

    conclusionsRowClick(params){
      this.$router.push({ name: 'conclusion', params: { conclusion: params.row.slug } });
    },

    commonParametersRowClick(params){
      this.$router.push({ name: 'parameter-common', params: { parameter: params.row.slug } });
    },

    onTraitementRowClick(params){
      this.$router.push({ name: 'treatment', params: { treatment: params.row.slug } });
    },

    onAntecedentRowClick(params){
      if (params.row.hasOwnProperty('medecine')){
        this.$router.push({ name: 'consultation-general', params: { consultation: params.row.medecine } });
      }

      else if (params.row.hasOwnProperty('cardiology')){
        this.$router.push({ name: 'consultation-cardiology', params: { consultation: params.row.cardiology } });
      }
      else{
        this.$router.push({ name: 'antecedent', params: { antecedent: params.row.slug, file: this.generalConsultation.dossier.slug } });
      }
    },

    onAllergieRowClick(params){
      this.$router.push({ name: 'allergy', params: { allergy: params.row.slug } });
    },

    notEmpty(item){
      if (item)
        return item.length > 0;

      return false;
    },

    toAllergie(){
      this.$router.push({ name: 'add-allergy', params: { file: this.generalConsultation.dossier.slug } })
    },

    toCurrentTraitement(){
      this.$router.push({ name: 'add-treatments', params: { file: this.generalConsultation.dossier.slug } })
    },

    toAddReason() {
      this.$router.push({ name: 'add-consultation-reason', params: { consultation: this.consultation_id } })
    },

    toAddCommonParameter(){
      this.$router.push({name: 'add-parameter-common',params:{ consultation: this.consultation_id}})
    },

    toConclusion(){
      this.$router.push( { name: 'conclusions', params: { consultation: this.consultation_id } })
    },

    toAntecedent(){
      this.$router.push( { name: 'add-antecedent', params: { file: this.generalConsultation.dossier.slug }})
    },

    getConsultation() {
      let args = {
        consultation: this.consultation_id
      };

      this.$store.dispatch("getGeneralConsultation", { args });
    },

    formattedDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },

    updateConsultation() {
      localStorage.setItem('reload', 0);
      this.$router.push({ name: 'edit-consultation-general', params: { consultation: this.consultation_id } });
    },

    deleteConsultation() {
      let self = this;
      let args = {
        consultation: this.consultation_id
      };

      let successMessage = this.$i18n.t('message.generalConsultationDeleted');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('deleteGeneralConsultation', { args, index: self.consultation_id, successMessage, errorMessages }).then(() => {
        self.$bvModal.hide('delete-modal');
        this.$router.back();

      });
    },

    archieveConsultation(){
      let self = this;
      let args = {
        consultation: this.consultation_id
      };

      let successMessage = this.$i18n.t('message.medecineConsultationArchieved');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('archieveMedecineConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

    },
    getVerification(c){
      if(c ===true){
        return "Oui"
      }else{
        return "Non"
      }
    },
    // getCapitalizeFirstLetter(c){
    //   if(!c){}
    //   return c.charAt(0).toUpperCase() + c.slice(1);
    // },

    transmitConsultation(){
      let self = this;
      let args = {
        consultation: this.consultation_id
      };

      let successMessage = this.$i18n.t('message.medecineConsultationTransmitted');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('transmitMedecineConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

    },

    reactiveConsultation(){
      let self = this;
      let args = {
        consultation: this.consultation_id
      };

      let successMessage = this.$i18n.t('message.medecineConsultationReactived');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('reactiveMedecineConsultation', { args, index: self.consultation_id, successMessage, errorMessages });

    },

    isArchived:function(date){
      let momentDate = moment(date);
      return !momentDate.isValid() ;
    },

    isTransmitted:function(date){
      var momentDate = moment(date);
      return !momentDate.isValid() ;
    },

    getErrorsField(field){
      if (this.errorshasField(field)){
        return this.errors[field][0];
      }else{
        return  '';
      }
    },
    errorshasField(field){
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },
    clearErrorField(field){
      this.$store.dispatch('clearErrorField', { field });
      this.getErrorsField(field);
    },
    pathHas(element){
      let result = (this.$route.fullPath).includes(element);
      if(result){
        if ($('#'+element).length){
          document.getElementById(element).scrollIntoView(top);
        }
      }

      return result;
    },
    getTranslate(c){
      let glycated = this.$i18n.t('message.glycated');
      let glycemie = this.$i18n.t('message.glycemie');
      let cholestorol = this.$i18n.t('message.cholestorol');
      let hdl = this.$i18n.t('message.hdl');
      let ldl = this.$i18n.t('message.ldl');
      let tags = this.$i18n.t('message.tags');
      let malnutrition = this.$i18n.t('message.malnutrition');
      let deshydradation = this.$i18n.t('message.deshydradation');
      if (c=== "glycated") {
        return  glycated;
      }
      if (c=== "glycemie") {
           return  glycemie;
      }
      if (c=== "cholestorol") {
           return  cholestorol;
      }
      if (c=== "hdl") {
           return  hdl;
      }
      if (c=== "ldl") {
           return  ldl;
      }
      if (c=== "tags") {
           return  tags;
      }
      if (c=== "malnutrition") {
           return  malnutrition;
      }
      if (c=== "deshydratation") {
           return  deshydradation;
      } 
    }
  },

  mounted() {
    this.getConsultation();
  },

}
</script>

<style scoped>

</style>
